var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Instagram1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-instagram 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.017 41.99L14.017 42.009C9.61699 42.013 6.01399 38.417 6.00899 34.017L5.98999 14.017C5.98599 9.61699 9.58199 6.01399 13.982 6.00899L33.982 5.98999C38.382 5.98599 41.985 9.58199 41.99 13.982L42.009 33.982C42.014 38.383 38.417 41.986 34.017 41.99Z",
    fill: "url(#paint0_radial_3137_7806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.017 41.99L14.017 42.009C9.61699 42.013 6.01399 38.417 6.00899 34.017L5.98999 14.017C5.98599 9.61699 9.58199 6.01399 13.982 6.00899L33.982 5.98999C38.382 5.98599 41.985 9.58199 41.99 13.982L42.009 33.982C42.014 38.383 38.417 41.986 34.017 41.99Z",
    fill: "url(#paint1_radial_3137_7806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24 31C20.141 31 17 27.86 17 24C17 20.14 20.141 17 24 17C27.859 17 31 20.14 31 24C31 27.86 27.859 31 24 31ZM24 19C21.243 19 19 21.243 19 24C19 26.757 21.243 29 24 29C26.757 29 29 26.757 29 24C29 21.243 26.757 19 24 19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.5 18C32.3284 18 33 17.3284 33 16.5C33 15.6716 32.3284 15 31.5 15C30.6716 15 30 15.6716 30 16.5C30 17.3284 30.6716 18 31.5 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M30 37H18C14.141 37 11 33.86 11 30V18C11 14.14 14.141 11 18 11H30C33.859 11 37 14.14 37 18V30C37 33.86 33.859 37 30 37ZM18 13C15.243 13 13 15.243 13 18V30C13 32.757 15.243 35 18 35H30C32.757 35 35 32.757 35 30V18C35 15.243 32.757 13 30 13H18Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3137_7806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.38 42.035) scale(44.899 44.899)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3137_7806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.786 5.5403) scale(29.813 19.8644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Instagram1);
export default __webpack_public_path__ + "static/media/icons8-instagram 1.5dd061f81db8a86d3fff4792581d03a4.svg";
export { ForwardRef as ReactComponent };